import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { loadData } from '../core/duck/actions'
import styled from 'styled-components'
// import Chip from '@material-ui/core/Chip'
// import Avatar from '@material-ui/core/Avatar'
import Masonry from 'react-masonry-component'
import Simple from '../shared/SimpleCard'
import Double from '../shared/DoubleCard'
import Typography from '@material-ui/core/Typography'
import Loader from '../shared/Loader'
import { getAssetClassItemsFromSelections, getFactoidsFromSelections, getFactoidWidth, isSimpleFactoidLayout, cleanString, cleanFactoidStrings, sortCardSizes } from '../lib/helpers'
import Requests from 'src/lib/requests';

interface IChipDetails {
  name: string
  id: string
}

interface IProps extends RouteComponentProps<{}> {
  loadData: () => void
  data: any
  loadingData: boolean
}

interface IState {
  viewData: {
    factoids: any[]
    classes: any[]
    name: string
    businessLines: any[]
  }
}

class View extends React.Component<IProps, IState> {
  public state = {
    viewData: {
      factoids: [],
      classes: [],
      name: '',
      businessLines: []
    }
  }
  public async componentDidMount() {
    // Load all classes, factoids and business lines from WP
    this.props.loadData()
    const params: any = { ...this.props.match.params }
    let viewRes
    try {
      viewRes = await Requests.getView(params.id);
    } catch (e) {
      console.log('error getting view',e)
    }

    // Structure the view data meaningfully and set to state
    if (viewRes) {
      this.setState({
        viewData: {
          factoids: viewRes.data.acf.factoids,
          classes: viewRes.data.acf.classes,
          name: viewRes.data.title.rendered,
          businessLines: viewRes.data.acf.business_lines
        }
      })
    } else {
      this.props.history.push('/views/new')
    }

  }

  public createBlockObject = (businessLine: any) => {
    const { viewData } = this.state
    const { factoids } = this.props.data
    const factoidData = this.props.data.factoids
    // Map out all the ID's of the factoids from the view
    const factoidSelections: number[] = viewData.factoids.map((factoid: any) => factoid.ID)
    // Get all the factoid objects
    let factoidItems = getFactoidsFromSelections(factoidSelections, factoidData).map(cleanFactoidStrings)
    
    const agents = factoids.filter(
      (factoid: any) => factoid.acf.type.name === 'Person'
    ).map(cleanFactoidStrings)
    const agentIds = agents.map((agent: any) => agent.id)
    const articles = factoids.filter(
      (factoid: any) => factoid.acf.type.name === 'Case study' || factoid.acf.type.name === 'Research'
    ).map(cleanFactoidStrings)
    const articleIds = articles.map((article: any) => article.id)

    // @ts-ignore
    factoidItems = factoidItems.filter((factoid: any) => ![...agentIds, ...articleIds].includes(factoid.id))

  return {
      name: cleanString(businessLine.name),
      description: cleanString(businessLine.description),
      factoids: factoidItems.filter((factoidItem: any) =>
        factoidItem.business_line.includes(businessLine.term_id)
      ),
      team: agents.filter((agent: any) => agent.business_line.includes(businessLine.term_id)),
      articles: articles.filter((article: any) =>
        article.business_line.includes(businessLine.term_id)
      )
    }
  }


  public render() {
    const { viewData } = this.state
    const classesData = this.props.data.classes
     // Map out all the ID's of the asset classes from the view
     const classSelections: number[] = viewData.classes.map(
      (classItem: any) => classItem.term_id
    )

    const classItems = getAssetClassItemsFromSelections(classSelections ,classesData)
   
    // Object which will be mapped over to create sections of each BL
    const blocks = viewData.businessLines.map(this.createBlockObject)

    // If any blocks don't have factoids, let's push them towards end of array.
    blocks.forEach((block: any, index: number) => {
      if (!block.factoids.length) {
        blocks.push(blocks.splice(index, 1)[0])
      }
    })

    // Presentational component, shows asset classes from the view
    const AssetClassChip = (classItem: IChipDetails) => {
      const ContainerSlantA = styled.div`
        margin-right: 16px;
        font-size: 13px;
        position: relative;
        display: inline-block;
        overflow: hidden;
        color: #000;
        padding: 0.4em 2em 0.4em 3em;
        &:after {
          background-color: ${"#e0e0e0"};
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          -webkit-transform-origin: 100% 0;
          -ms-transform-origin: 100% 0;
          transform-origin: 100% 0;
          -webkit-transform: skew(-25deg);
          -ms-transform: skew(-25deg);
          transform: skew(-25deg);
          z-index: -1;
        }
      `
      const DeleteSpanA = styled.div`
        padding: 0 0.7em;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        cursor: pointer;
        background-color: rgb(181,181,181);
        color: rbg(86,86,86);
        display: flex;
        jusify-content: center;
        align-items: center;
      `
      const TextSpanA = styled.span`
      `
      return (
        <ContainerSlantA color={"#fff"}>
          <DeleteSpanA> <span> {classItem.name.slice(0, 2).toUpperCase()} </span> </DeleteSpanA>
          <TextSpanA>{classItem.name}</TextSpanA>
        </ContainerSlantA>
      )
    }
    // const AssetClassChip = (classItem: IChipDetails) => (
    //   <Chip
    //     key={classItem.id}
    //     style={{
    //       backgroundColor: '#e0e0e0',
    //       marginRight: '10px',
    //       color: '#000'
    //     }}
    //     avatar={<Avatar>{classItem.name.slice(0, 2).toUpperCase()}</Avatar>}
    //     label={classItem.name}
    //   />
    // )

    // Map out the Blocks we had created!
    const BusinessLineBlocks = blocks.map((block: any): React.ReactNode => {
      return (
        <BlockOuter key={block.name}>
          <Typography
            variant="display1"
            gutterBottom={true}
            style={{ color: '#2A86A9', textTransform: 'uppercase' }}
          >
            {block.name}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom={true}
            style={{
              color: '#395E80',
              fontSize: '23px',
              paddingBottom: '20px',
              fontWeight: 300
            }}
          >
            {block.description}
          </Typography>
            <Masonry
            className='row'
              options={{ transitionDuration: 0 }}
              disableImagesLoaded={false}
              updateOnEachImageLoad={false}
              
            >
              {sortCardSizes(block.factoids).map((factoid: any): React.ReactNode => {
                const width = getFactoidWidth(factoid)
                if (isSimpleFactoidLayout(factoid)) {
                  return (
                    <MasonryCardOuter className={width} key={factoid.id}>
                    <Simple
                      item={factoid}
                      hideAdd={true}
                      landingPage={true}
                    />
                    </MasonryCardOuter>
                  )
                } else {
                  return (
                    <MasonryCardOuter
                      className={width}
                      key={factoid.id}
                    >
                      <Double
                        item={factoid}
                        hideAdd={true}
                        landingPage={true}
                      />
                    </MasonryCardOuter>
                  )
                }
              })}
            </Masonry>
            
          {block.team.length > 0 && (
            <React.Fragment>
              <Typography
                variant="display1"
                gutterBottom={true}
                style={{
                  color: '#2A86A9',
                  textTransform: 'uppercase',
                  marginTop: '40px'
                }}
              >
                Team
              </Typography>
              <Masonry
                className='row'
                options={{ transitionDuration: 0 }}
                disableImagesLoaded={false}
                updateOnEachImageLoad={false}
              >
                {block.team.map((agent: any): React.ReactNode => {
                  const width = getFactoidWidth(agent)
                  if (isSimpleFactoidLayout(agent)) {
                    return (
                      <MasonryCardOuter
                        className={width}
                        key={agent.id}
                      >
                        <Simple item={agent} hideAdd={true} />
                      </MasonryCardOuter>
                    )
                  } else {
                    return (
                      <MasonryCardOuter
                        className={width}
                        key={agent.id}
                      >
                        <Double item={agent} hideAdd={true} />
                      </MasonryCardOuter>
                    )
                  }
                })}
              </Masonry>
            </React.Fragment>
          )}

          {block.articles.length > 0 && (
            <React.Fragment>
              <Typography
                variant="display1"
                gutterBottom={true}
                style={{
                  color: '#2A86A9',
                  textTransform: 'uppercase',
                }}
              >
                Recommended articles
              </Typography>
              <Masonry
                className='row'
                options={{ transitionDuration: 0 }}
                disableImagesLoaded={false}
                updateOnEachImageLoad={false}
              >
                {sortCardSizes(block.articles).map((article: any): React.ReactNode => {
                  const width = getFactoidWidth(article)
                  return (
                    <MasonryCardOuter
                      className={width}
                      key={article.id}
                    >
                      <Simple
                        item={article}
                        landingPage={true}
                        hideAdd={true}
                      />
                    </MasonryCardOuter>
                  )
                })}
              </Masonry>
            </React.Fragment>
          )}
        </BlockOuter>
      )
    })

    return (
      <Outer>
        {this.props.loadingData ? (
          <LoaderOuter>
            <Loader />
          </LoaderOuter>
        ) : (
          <React.Fragment>
            <Typography
              variant="display2"
              gutterBottom={true}
              style={{ color: '#E4002B', textTransform: 'uppercase' }}
              className="heading"
            >
            Cushman &amp; Wakefield
            </Typography>
            <Content>
              <ClassChips>
                {classItems.map((classItem: any) =>
                  AssetClassChip({
                    name: classItem.name,
                    id: classItem.id
                  })
                )}
              </ClassChips>
              {BusinessLineBlocks}
            </Content>
          </React.Fragment>
        )}
      </Outer>
    )
  }
}

const mapStateToProps = (state: any) => ({
  data: state.data,
  loadingData: state.data.loading
})

export default connect(
  mapStateToProps,
  { loadData }
)(View)

const Outer = styled.div`
  margin-top: 200px;

  .heading {
    font-size: 30px;
    margin-left: 20px;
  }
`

const Content = styled.div`
  margin: 0 auto;
  width: 95%;
`

const BlockOuter = styled.div`
  padding: 50px 0px;
`

const LoaderOuter = styled.div`
  margin-top: 150px;
`

const ClassChips = styled.div`
  margin-left: 20px;
  padding: 20px 0px;
`

const MasonryCardOuter = styled.div`
  margin-bottom: 20px;
  transition: all 0.5s;
`



// WEBPACK FOOTER //
// ./src/view/View.tsx